// รูปเกมที่โหลดไม่ได้ (ลิงก์จาก API เสีย) -> แสดงกล่องชื่อเกมแทนช่องว่าง
function placeholder(text) {
  const t = String(text || 'GAME').slice(0, 22).replace(/[<&>"]/g, '');
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="180" height="261" viewBox="0 0 180 261">
<defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#123312"/><stop offset="1" stop-color="#061206"/></linearGradient></defs>
<rect width="180" height="261" rx="6" fill="url(#g)" stroke="#2fbf2f" stroke-opacity=".5"/>
<text x="90" y="135" font-family="Kanit,sans-serif" font-size="15" fill="#d8ffd8" text-anchor="middle">${t}</text></svg>`;
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}
window.addEventListener('error', (e) => {
  const img = e.target;
  if (!img || img.tagName !== 'IMG' || img.dataset.fallback) return;
  if (!img.closest('.uael-grid-img-thumbnail, .x-game-list-item-macro, .gl-card')) return;
  img.dataset.fallback = '1';
  img.src = placeholder(img.getAttribute('alt') || img.getAttribute('title'));
}, true);
